module.exports = __webpack_public_path__ + "img/cook_7-7-2021.0f03f99c.jpg";